import React, {Component} from 'react'
import {Form, Header, Icon, Grid} from 'semantic-ui-react'
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css'
import {Number, Cvc, Expiration} from 'react-credit-card-primitives'

class PaymentDetails extends Component {

    constructor(props) {
        super(props)
        let today = new Date()
        this.state = {
            today: today,
            selectedMonth: props.data.billing.selectedMonth || today.getMonth(),
            selectedYear: props.data.billing.selectedYear || today.getFullYear(),
            cardNumber: props.data.billing.cardNumber || "",
            expMonth: props.data.billing.expMonth || "",
            expYear: props.data.billing.expYear || "",
            cardCode: props.data.billing.cardCode || "",
            focused: "name"
        }
    }


    handleNumberChange = (value) => {
        this.props.change('billing.cardNumber', value)
    }
    handleExpiryChange = (month, year) => {
        this.props.change('billing.selectedMonth', month || this.state.today.getMonth())
        this.props.change('billing.selectedYear', year || this.state.today.getFullYear())
    }
    handleCvcChange = (value) => {
        this.props.change('billing.cardCode', value)

    }
    onNewFocus = (focused) => {
        setTimeout(() => {
            this.setState({focused})
        }, 100)
    }
    onBlur = () => {
        setTimeout(() => {
            this.setState({focused: "name"})
        }, 100)
    }

    render() {
        let expiryValue = (this.props.data.billing.selectedMonth >= 10 ? this.props.data.billing.selectedMonth : "0" + this.props.data.billing.selectedMonth) + "" + this.props.data.billing.selectedYear
        return (
            <div>
                <Header as='h3' dividing>
                    <Icon name='payment'/>
                    <Header.Content>
                        Payment Information
                        <Header.Subheader>
                            Manage your payment method and information
                        </Header.Subheader>
                    </Header.Content>
                </Header>
                <Grid>
                    <Grid.Column largeScreen={9} widescreen={9} mobile={16} tablet={9} computer={16}>
                        <Cards
                            number={this.props.data.billing.cardNumber}
                            name={this.props.data.billing.first_name + " " + this.props.data.billing.last_name}
                            expiry={expiryValue}
                            cvc={this.props.data.billing.cardCode}
                            focused={this.state.focused}
                        />
                    </Grid.Column>
                    <Grid.Column largeScreen={7} widescreen={7} mobile={16} tablet={7} computer={16}>

                        <Form.Field onFocus={() => {
                            this.onNewFocus("number")
                        }} onBlur={this.onBlur.bind(this)}>
                            <label>Card Number</label>
                            <Number
                                value={this.props.data.billing.cardNumber}
                                onChange={({value, valid}) => {
                                    this.handleNumberChange(value)
                                }}
                                render={({getInputProps, valid}) => {
                                    return (
                                        <input
                                            {...getInputProps()}
                                            className={valid ? '' : 'error'}/> )
                                }}/>
                        </Form.Field>

                        <Form.Group>
                            <Form.Field width={8} onFocus={() => {
                                this.onNewFocus("expiry")
                            }} onBlur={this.onBlur.bind(this)}>
                                <label>Expiry</label>
                                <Expiration
                                    defaultMonth={this.props.data.billing.selectedMonth || this.state.today.getMonth()}
                                    defaultYear={this.props.data.billing.selectedYear || this.state.today.getFullYear()}
                                    onChange={({month, year, valid}) => {
                                        this.handleExpiryChange(month, year)
                                    }}
                                    render={({getInputProps, valid, error}) => {
                                        return (
                                            <div>
                                                <input
                                                    {...getInputProps()} className={valid ? '' : 'error'}/>
                                            </div>
                                        )
                                    }}/>
                            </Form.Field>

                            <Form.Field width={8} onFocus={() => {
                                this.onNewFocus("cvc")
                            }} onBlur={this.onBlur.bind(this)}>
                                <label>CVC</label>
                                <Cvc
                                    value={this.props.data.billing.cardCode}
                                    onChange={({value, valid}) => {
                                        this.handleCvcChange(value)
                                    }}
                                    render={({getInputProps, valid, focused}) => {
                                        return (
                                            <input
                                                {...getInputProps()}
                                                className={valid ? '' : 'error'}/>)
                                    }}/>
                            </Form.Field>
                        </Form.Group>
                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}

export default PaymentDetails


// WEBPACK FOOTER //
// ./src/containers/register/PaymentDetails.js